import { render } from "./input-text.vue?vue&type=template&id=4cb1d249"
import script from "./input-text.vue?vue&type=script&lang=js"
export * from "./input-text.vue?vue&type=script&lang=js"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__